module.exports = __webpack_public_path__ + "static/img/rank_avatar_frame_platinum.0a898608.png";